import { useTranslation } from 'react-i18next';
import { BpPage } from 'components/BpPage/BpPage';
import { BpCard } from 'components/BpCard/BpCard';
import { AboutBP } from 'components/AboutBP/AboutBP';
import { Button } from '@bp/ui-components';
import { useNavigate } from 'react-router-dom';

export const AboutPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BpPage title={t('app.title.full')} isForbidden={false} noHeadlineMargin hideBreadcrumbs>
      <BpCard>
        <AboutBP isAdmin={false} matrixOnline={true} />
      </BpCard>
      <BpCard hideBackground>
        <Button>{t('common.back')}</Button>
      </BpCard>
    </BpPage>
  );
};
